import {
  getHistoryStoreDataPending,
  getHistoryStoreDataSuccess,
  getHistoryStoreDataError,
} from './index';
import config from '../../oktaConfig';

/**
 * Fetch historical store health data for a given date and geo/region.
 * The exact response shape is handled by the consumer; this action only
 * retrieves and stores the raw API payload.
 *
 * @param {string} accessToken - Okta access token
 * @param {{ date: string; geo?: string }} params - Query params for the request
 */
function getHistoryStoreData(accessToken, params = {}) {
  const {date, geo} = params;

  return dispatch => {
    dispatch(getHistoryStoreDataPending());

    const url = new URL(config.resourceServer.insightsApiUrlHistoryStoreData);
    if (date) {
      url.searchParams.append('Date', date);
    }
    if (geo) {
      // Align with existing API convention that uses `Geo` as the query key.
      url.searchParams.append('Geo', geo);
    }

    fetch(url.toString(), {
      mode: 'cors',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(
            new Error(
              `Failed to fetch history store data: ${response.status} ${response.statusText}`
            )
          );
        }
        return response.json();
      })
      .then(data => {
        dispatch(getHistoryStoreDataSuccess(data));
      })
      .catch(err => {
        dispatch(getHistoryStoreDataError(err));
        // eslint-disable-next-line no-console
        console.error('Unable to retrieve history store data', err);
      });
  };
}

export default getHistoryStoreData;
